const skills = [
  "Semantic & accessible HTML",
  "Responsive Web Design",
  "Markdown",
  "Immutability",
  "CSS BEM convention",
  "CSS Grid",
  "CSS Flexbox",
  "React Router",
  "Redux-Saga",
  "Redux (Toolkit)",
  "React Hooks",
  "Error handling",
  "Working with API (fetch, axios)",
  "JavaScript: ES6+",
  "Promises, Async/Await",
  "GitHub Pull Requests & Review",
  "Trello",
  "Scrum",
  "NPM",
  "React",
  "Git",
];
const learnNext = [
  "React Context",
  "Node.js",
  "React Native",
  "Unit testing",
  "TypeScript",
  "JS classes",
];
export { skills, learnNext };
